import { html } from '@polymer/polymer/polymer-element';
import { KatapultWidget } from './katapult-widget';

class TestWidget extends KatapultWidget {
  static get widgetTitleTemplate() {
    return html`TEST`;
  }
}
window.customElements.define('test-widget', TestWidget);
